import { getSafeStoreInfoRequestContext } from '#shared/lib/context';

export const useStoreIsBannedBannerOpen = () => {
    const isBanned = getSafeStoreInfoRequestContext().isBanned;

    return isBanned;
};
